// @flow strict
import * as React from 'react'
import { Link } from 'gatsby'
import {
  AccessibilityText,
  ChevronDown,
  renderDate,
} from '@mondough/public-web-components'

import styles from './BlogHeader.module.scss'

export type Props = {
  publishedDate: string,
  category: {
    name: string,
    link: string,
  },
  children: string,
}

const BlogHeader = ({ children, publishedDate, category }: Props) => {
  return (
    <header className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.metadata}>
          <time
            dateTime={renderDate(publishedDate, 'DD-MM-YYYY')}
            className={styles.date}
          >
            <AccessibilityText>Published on: </AccessibilityText>
            {renderDate(publishedDate, 'DD-MONTH-YYYY')}
          </time>
          <Link to={category.link} className={styles.link}>
            <AccessibilityText>Published in: </AccessibilityText>
            {category.name}
          </Link>
        </div>
        <h1 className={styles.title}>{children}</h1>
        <a href="#article" className={styles.anchor}>
          <ChevronDown />
          <AccessibilityText>Read the article</AccessibilityText>
        </a>
      </div>
    </header>
  )
}

export default BlogHeader
